var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSea02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.699219,
    y: 0.529297,
    width: 350,
    height: 233,
    fill: "#E09064"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.227 91.413L274.519 89.6997C273.575 88.7534 271.969 88.8301 270.931 89.871L199.525 161.489C198.487 162.53 198.411 164.141 199.354 165.087L201.062 166.8C202.006 167.746 203.612 167.67 204.65 166.629L276.056 95.011C277.094 93.9702 277.171 92.3593 276.227 91.413Z",
    fill: "#F3F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.227 91.413L274.519 89.6997C273.575 88.7534 271.969 88.8301 270.931 89.871L265.807 95.011L270.931 100.151L276.056 95.011C277.094 93.9702 277.171 92.3593 276.227 91.413Z",
    fill: "#FCFCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.879 147.344L229.086 131.842L253.029 107.828L258.154 112.968L223.879 147.344Z",
    fill: "#171F48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.059 90.8359L222.142 107.969L218.89 111.23C218.5 111.621 217.868 111.621 217.478 111.23L201.807 95.5132C201.417 95.1221 201.417 94.488 201.807 94.0969L205.059 90.8359Z",
    fill: "#33449A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.305 142.238L273.388 159.372L270.136 162.633C269.746 163.024 269.114 163.024 268.724 162.633L253.053 146.916C252.663 146.524 252.663 145.89 253.053 145.499L256.305 142.238Z",
    fill: "#F3F5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.139 107.975L256.288 142.225L253.037 145.486C252.647 145.877 252.014 145.877 251.624 145.486L218.887 112.652C218.497 112.261 218.497 111.627 218.887 111.236L222.139 107.975Z",
    fill: "#9BA9F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M269.934 94.3047C269.934 94.3047 272.53 126.104 256.284 142.295L273.35 159.412C292.227 140.479 288.81 113.237 269.934 94.3047Z",
    fill: "#33449A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M269.933 94.304C251.057 75.3715 223.878 71.962 205.018 90.8773L222.084 107.994C238.21 91.6826 269.933 94.304 269.933 94.304Z",
    fill: "#9BA9F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236.567 78.3397C248.377 78.9628 260.247 84.5901 269.931 94.3032C269.931 94.3032 256.836 93.221 243.195 96.7736C238.132 88.7923 236.667 81.1588 236.567 78.3397Z",
    fill: "#C3CCFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M285.907 127.723C285.254 115.879 279.61 103.99 269.9 94.3037C269.9 94.3037 271.014 107.435 267.51 121.126C275.481 126.182 283.096 127.631 285.907 127.723Z",
    fill: "#5167D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.918 94.3183L269.933 94.3037L269.916 94.2866C269.916 94.2866 269.917 94.2972 269.918 94.3183ZM239.114 125.077L222.084 107.996C227.869 102.144 235.658 98.7245 243.268 96.7454C256.869 93.208 269.899 94.2718 269.899 94.2718L255.102 109.113L269.918 94.3183C270.005 95.4463 272.232 126.399 256.266 142.277L256.232 142.243L239.112 125.079L239.114 125.077Z",
    fill: "#F3F5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M243.268 96.7442C256.869 93.2068 269.899 94.2706 269.899 94.2706L254.524 109.691L243.268 96.7442Z",
    fill: "#FAFBFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M267.434 120.984C270.961 107.343 269.9 94.2744 269.9 94.2744L254.525 109.694L267.434 120.984Z",
    fill: "#FAFBFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.098,
    cy: 87.9858,
    rx: 10.8833,
    ry: 10.9155,
    fill: "#F3F5FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea02);
export default __webpack_public_path__ + "static/media/sea_02.a2d666bccf905d7306e8d30714fb8e6c.svg";
export { ForwardRef as ReactComponent };